module.exports = __webpack_public_path__ + "img/food-item-default.3c611929.webp";